<!-- Page Footer -->
<div class="hk-footer">
    <footer class="container-xxl footer">
        <div class="row">
            <div class="col-xl-12">
                <p class="footer-text text-white"><span class="copy-text">eastcoast.engineering © 2026 All rights reserved.</span></p>
            </div>
          
        </div>
    </footer>
</div>
<!-- / Page Footer -->